import { configService } from "./Config/ConfigService";

class AbpnClient {
    private _baseUri: string | undefined;
    private _errorPage: string | undefined;

    private async ensureConfiguration() {
        if (this._baseUri) return;

        this._baseUri = (await configService.getConfiguration()).AbpnApiUrl;
    }

    private async getDefaultHeaders() {
        const headers = [];
        headers.push(['Pragma', 'no-cache']);
        return headers;
    }

    private async validateResponse(response: Response): Promise<Response> {
        if (response.status === 401) {
            throw Error('Unauthorized');
        }
        if (!response.ok) {
            var clone = response.clone();
            const text = await clone.text();
            throw Error(`(${response.statusText}) ${text}}`);
        }
        return Promise.resolve(response);
    }

    private async castResponse<T>(response: Response): Promise<T | null> {
        const text = await response.text();
        if (!text) {
            return null;
        }
        return JSON.parse(text) as T;
    }

    private async handleError(error: any): Promise<any> {
        if (this._errorPage) {
            window.location.href = this._errorPage;
        }
        return Promise.reject(error);
    }

    setErrorPage(errorPage: string) {

        this._errorPage = errorPage;
    }

    async post<T>(relativePath: string, body: any): Promise<T> {
        await this.ensureConfiguration();

        const headers = await this.getDefaultHeaders();
        headers.push(["Content-Type", "application/json"]);
        return fetch(this._baseUri + relativePath,
            {
                method: "post",
                headers: headers,
                body: JSON.stringify(body)
            })
            .then(this.validateResponse)
            .then(response => this.castResponse<T>(response))
            .catch(error => this.handleError(error));
    }

    async postStringResponse<T>(relativePath: string, body: any): Promise<T> {
        await this.ensureConfiguration();

        const headers = await this.getDefaultHeaders();
        headers.push(["Content-Type", "application/json"]);
        return fetch(this._baseUri + relativePath,
            {
                method: "post",
                headers: headers,
                body: JSON.stringify(body)
            })
            .then(this.validateResponse)
            .catch(error => this.handleError(error));
    }

    async get<T>(relativePath: string): Promise<T> {
        await this.ensureConfiguration();

        const headers = await this.getDefaultHeaders();
        return fetch(this._baseUri + relativePath, {
            method: "GET",
            headers: headers
        })
            .then(this.validateResponse)
            .then(response => this.castResponse<T>(response))
            .catch(error => this.handleError(error));
    }

    async getResponse(relativePath: string): Promise<any> {
        await this.ensureConfiguration();

        const headers = await this.getDefaultHeaders();
        return fetch(this._baseUri + relativePath, {
            headers: headers
        })
            .then(this.validateResponse)
            .catch(error => this.handleError(error));
    }
}
export const abpnClient = new AbpnClient();